// - Import action types
import { UserActionType } from 'constants/userActionType';
import { Map } from 'immutable';
import { UserState } from './UserState';
/**
 * User reducer
 */
export var userReducer = function (state, action) {
    if (state === void 0) { state = Map(new UserState()); }
    var payload = action.payload;
    switch (action.type) {
        case UserActionType.USER_INFO:
            return state
                .setIn(['info', payload.uid], payload.info);
        case UserActionType.ADD_USER_INFO:
            return state
                .setIn(['info', payload.uid], payload.info)
                .set('loaded', true);
        case UserActionType.ADD_PEOPLE_INFO:
            return state
                .mergeIn(['info'], payload);
        case UserActionType.UPDATE_USER_INFO:
            return state
                .mergeIn(['info', payload.uid], payload.info);
        case UserActionType.CLEAR_ALL_DATA_USER:
            return Map(new UserState());
        case UserActionType.CLOSE_EDIT_PROFILE:
            return state
                .set('openEditProfile', false);
        case UserActionType.OPEN_EDIT_PROFILE:
            return state
                .set('openEditProfile', true);
        case UserActionType.HAS_MORE_DATA_PEOPLE:
            return state
                .setIn(['people', 'hasMoreData'], true);
        case UserActionType.NOT_MORE_DATA_PEOPLE:
            return state
                .setIn(['people', 'hasMoreData'], false);
        case UserActionType.REQUEST_PAGE_PEOPLE:
            return state
                .setIn(['people', 'lastPageRequest'], payload.page);
        case UserActionType.LAST_USER_PEOPLE:
            return state
                .setIn(['people', 'lastUserId'], payload.lastUserId);
        default:
            return state;
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/users/userReducer.ts
// module id = 572
// module chunks = 50